module.exports = __webpack_public_path__ + "media/components/assets/icons/sidebar_event-b8260c3f690619b77b61dba587f02c9a.svg";